import React from 'react';
import ReactDOMServer from 'react-dom/server';

import { Tip } from './Tip';
import { CTAEmbed } from './CTAEmbed';
import EmbeddedTemplate from './EmbeddedTemplate';

function extractArguments(str) {
  if (typeof str !== 'string') return [];
  return str.split('|').map((s) => s.trim());
}

export default React.memo(({ html }) => {
  // ? Embedded templates
  html = html.replace(/\[TEMPLATE:(.*?)\]/g, (m, c) => {
    const [slug] = extractArguments(c);
    const component = <EmbeddedTemplate slug={slug} />;
    return ReactDOMServer.renderToStaticMarkup(component);
  });

  // ? Embedded CTAs
  html = html.replace(/\[CTA:?(.*?)\]/g, (m, c) => {
    const [title, description, cta] = extractArguments(c || '');

    return ReactDOMServer.renderToStaticMarkup(
      <CTAEmbed title={title} description={description} buttonText={cta} />,
    );
  });

  // ? Embedded Newsletters

  html = html.replace(/\[NEWSLETTER:?(.*?)\]/g, (m, c) => {
    const [title = '', byline = '', cta = '', tag = ''] = extractArguments(c);
    return ReactDOMServer.renderToStaticMarkup(
      <iframe
        title={title}
        data-src={`/newsletter?_noga=1&title=${encodeURIComponent(
          title,
        )}&byline=${encodeURIComponent(byline)}&cta=${encodeURIComponent(
          cta,
        )}&tag=${encodeURIComponent(tag)}`}
        style={{ width: '100%', height: '300px' }}
        frameBorder={0}
      />,
    );
  });

  // Tips
  html = html.replace(
    /<p[^>]*?>\s*<strong>.*Tip:<\/strong>(.*?)<\/p>/g,
    (m, tipText) =>
      ReactDOMServer.renderToStaticMarkup(<Tip tipText={tipText} />),
  );

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
});
